"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgLive(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "auto",
    viewBox: "0 0 22 7",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M4.74179 5.53015V7H0V0H1.77575V5.53015H4.74179Z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M7.93332 7H6.15756V0H7.93332V7Z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M13.728 7H11.4829L9.23296 0H11.27L12.6103 5.15177H12.7022L14.0038 0H15.9199L13.728 7Z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M22 5.56895V7H17.2147V0H22V1.43105H18.9904V2.82814H21.821V4.13791H18.9904V5.56895H22Z",
    fill: "inherit"
  }));
}

var _default = SvgLive;
exports.default = _default;